module.exports = __webpack_public_path__ + "img/h_1_hdl.420ef177.png";